/** Shared SVG card for schema nodes and record relationships. */
export function GraphNodeCard({ x, y, title, subtitle, colour }: {
  x: number; y: number; title: string; subtitle: string; colour: string
}) {
  return (
    <g>
      <title>{title} — {subtitle}</title>
      <rect className="graph-card-body" x={x - 84} y={y - 30} width={168} height={60} rx={8} stroke={colour} />
      <rect x={x - 72} y={y - 15} width={28} height={30} rx={6} fill={colour} fillOpacity={0.13} />
      <text className="graph-card-initial" x={x - 58} y={y + 4} fill={colour}>{title.slice(0, 1).toUpperCase()}</text>
      <text className="graph-card-title" x={x - 34} y={y - 3}>{title.length > 17 ? `${title.slice(0, 16)}…` : title}</text>
      <text className="graph-card-meta" x={x - 34} y={y + 13}>{subtitle.length > 25 ? `${subtitle.slice(0, 24)}…` : subtitle}</text>
    </g>
  )
}

/** Intersect a link with the card border so arrowheads remain visible. */
export function cardBoundary(from: { x: number; y: number }, to: { x: number; y: number }) {
  const dx = to.x - from.x
  const dy = to.y - from.y
  const factor = Math.min(dx === 0 ? Infinity : 84 / Math.abs(dx), dy === 0 ? Infinity : 30 / Math.abs(dy))
  if (!Number.isFinite(factor)) return to
  return { x: to.x - dx * factor, y: to.y - dy * factor }
}
